import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Card,
  Link,
  Typography,
  Container,
  styled,
  // Alert,
} from '@mui/material'
import { Helmet } from 'react-helmet-async'
import useAuth from 'src/hooks/useAuth'
import Auth0Login from '../LoginAuth0'
import FirebaseAuthLogin from '../LoginFirebaseAuth'
import JWTLogin from '../LoginJWT'
import AmplifyLogin from '../LoginAmplify'
import { useTranslation } from 'react-i18next'
import Scrollbar from 'src/components/Scrollbar'
import PortalPromo from 'src/components/PortalPromo'

const Content = styled(Box)(
  () => `
    display: flex;
    flex: 1;
    width: 100%;    
`
)

const MainContent = styled(Box)(
  ({ theme }) => `
  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0 0 0 440px;
  }
  width: 100%;  
  display: flex;  
  align-items: center;  
`
)

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: ${theme.colors.alpha.white[100]};
    width: 440px;
`
)

const SidebarContent = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(6)};
`
)

function LoginCover() {
  const { method } = useAuth()
  const { t } = useTranslation()

  return (
    <>
      <Helmet>
        <title>Login Youon</title>
      </Helmet>
      <Content>
        <SidebarWrapper
          sx={{
            display: { xs: 'none', md: 'flex' },
          }}
        >
          <Scrollbar>
            <SidebarContent>
              <PortalPromo logoWidth={250} />
            </SidebarContent>
          </Scrollbar>
        </SidebarWrapper>
        <MainContent>
          <Container
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // flexDirection: 'column',
            }}
            maxWidth="sm"
          >
            <Card
              sx={{
                p: 4,
                my: 4,
              }}
            >
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  sx={{
                    mb: 1,
                  }}
                >
                  {t('Entrar')}
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  fontWeight="normal"
                  sx={{
                    mb: 3,
                  }}
                >
                  {t('Preencha os campos abaixo para entrar em sua conta.')}
                </Typography>
              </Box>
              {/* sendo usado JWTLogin */}
              {method === 'Auth0' && <Auth0Login />}
              {method === 'FirebaseAuth' && <FirebaseAuthLogin />}
              {method === 'JWT' && <JWTLogin />}
              {method === 'Amplify' && <AmplifyLogin />}
              <Box my={4}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {t('Não tem uma conta ainda?')}
                </Typography>{' '}
                <Box display={{ xs: 'block', md: 'inline-block' }}>
                  <Link component={RouterLink} to="/account/register">
                    <b>Crie Aqui</b>
                  </Link>
                  {/* <Link component={RouterLink} to="/emailValidation">
                    <b>Email Validation </b>
                  </Link> */}
                </Box>
              </Box>
              {/* {method !== 'Auth0' && (
                <Tooltip
                  title={t('Used only for the live preview demonstration !')}
                >
                  <Alert severity="warning">
                    Use <b>demo@example.com</b> and password <b>TokyoPass1@</b>
                  </Alert>
                </Tooltip>
              )} */}
            </Card>
          </Container>
        </MainContent>
      </Content>
    </>
  )
}

export default LoginCover
